module.exports = __webpack_public_path__ + "static/media/1.4c46a34c.jpg";